<template>

  <div
      class="d-grid d-md-flex flex-wrap mb-2"
  >
    <div class="d-none d-sm-block d-md-flex p-0">
      <label for="street" class="form-label d-flex align-self-center m-0">{{$t('location.form.input.address.input.street_title')}}</label>
    </div>
    <div class="mb-sm-2 mb-md-0 ms-md-2">
      <input
          type="text"
          v-model="address.street"
          id="street"
          class="form-control d-md-flex"
          :placeholder="$t('location.form.input.address.input.street_placeholder')"
      />
    </div>



    <div class="d-none d-sm-blockW d-md-flex p-0 ms-md-2">
      <label for="s_number" class="form-label d-flex align-self-center m-0">{{$t('location.form.input.address.input.number_title')}}</label>
    </div>
    <div class="ms-md-2">
      <input
          type="text"
          v-model="address.number"
          class="form-control d-md-flex "
          :placeholder="$t('location.form.input.address.input.number_placeholder')"
          id="s_number"
      />
    </div>

  </div>

  <div
      class="d-grid d-md-flex flex-wrap mb-2"
  >
    <div class="d-none d-sm-block d-md-flex p-0">
      <label for="city" class="form-label d-flex align-self-center m-0">{{$t('location.form.input.address.input.city_title')}}</label>
    </div>
    <div class="mb-sm-2 mb-md-0 ms-md-2">
      <input
          type="text"
          v-model="address.city"
          id="city"
          class="form-control d-md-flex"
          :placeholder="$t('location.form.input.address.input.city_placeholder')"
      />
    </div>



    <div class="d-none d-sm-blockW d-md-flex p-0 ms-md-2">
      <label for="zip" class="form-label d-flex align-self-center m-0">{{$t('location.form.input.address.input.zip_code_title')}}</label>
    </div>
    <div class="ms-md-2">
      <input
          type="text"
          v-model="address.zip_code"
          class="form-control d-md-flex "
          :placeholder="$t('location.form.input.address.input.zip_code_placeholder')"
          id="zip"
      />
    </div>

  </div>

  <div
      class="d-grid d-md-flex flex-wrap mb-2"
  >
    <div class="d-none d-sm-block d-md-flex p-0">
      <label for="gps_lat" class="form-label d-flex align-self-center m-0">{{$t('location.form.input.address.input.lat_title')}}</label>
    </div>
    <div class="mb-sm-2 mb-md-0 ms-md-2">
      <input
          type="number"
          v-model="address.lat"
          id="gps_lat"
          class="form-control d-md-flex"
          :placeholder="$t('location.form.input.address.input.lat_placeholder')"
          :step="latLngStep"
      />
    </div>
    <div class="d-none d-sm-blockW d-md-flex p-0 ms-md-2">
      <label for="gps_lng" class="form-label d-flex align-self-center m-0">{{$t('location.form.input.address.input.lng_title')}}</label>
    </div>
    <div class="ms-md-2">
      <input
          type="number"
          v-model="address.lng"
          :step="latLngStep"
          class="form-control d-md-flex "
          :placeholder="$t('location.form.input.address.input.lng_placeholder')"
          id="gps_lng"
      />
    </div>

  </div>

  <div
      class="d-grid d-md-flex flex-wrap mb-2"
  >
    <div class="d-none d-sm-block d-md-flex p-0">
      <label for="district" class="form-label d-flex align-self-center m-0">{{$t('location.form.input.address.input.district_title')}}</label>
    </div>
    <div class="mb-sm-2 mb-md-0 ms-md-2">
      <input
          type="text"
          v-model="address.district"
          id="district"
          class="form-control d-md-flex"
          :placeholder="$t('location.form.input.address.input.district_placeholder')"

      />
    </div>
    <div class="d-none d-sm-blockW d-md-flex p-0 ms-md-2">
      <label for="code" class="form-label d-flex align-self-center m-0">{{$t('location.form.input.address.input.place_code_title')}}</label>
    </div>
    <div class="ms-md-2">
      <input
          type="text"
          v-model="address.code"

          class="form-control d-md-flex "
          :placeholder="$t('location.form.input.address.input.place_code_placeholder')"
          id="code"
      />
    </div>

  </div>

  <div
      v-if="formObj.general.inputs.display_type_id.val != 2"
      class="mapa"
  >
    <ol-map
        ref="mapObj"
        :loadTilesWhileAnimating="true"
        :loadTilesWhileInteracting="true"
        :zoom="15"
        style="height: 100%;"
        @moveend="onMoveEnd"
    >
      <!--  -->
      <ol-view
          ref="view"
          :center="fromLonLat(mapObj.center)"
          :zoom="mapObj.zoom"
      />
      <!-- Základní mapová vrstva -->
      <ol-tile-layer>

        <ol-source-xyz
            v-if="mapObj.mapBoxUrl"
            :url="mapObj.mapBoxUrl"
        />
        <ol-source-osm v-else />
      </ol-tile-layer>

      <!-- control -->
      <ol-fullscreen-control />



      <!-- markers -->
      <ol-vector-layer
          ref="vectorLayerMarker"
      >
        <ol-source-vector
            ref="vectorSourceMarker"
        >
        </ol-source-vector>
      </ol-vector-layer>

      <ol-overlay v-if="selectedMarker && selectedMarker.id" :position="fromLonLat([selectedMarker.lng, selectedMarker.lat])">
        <div class="info-box">
          <h4>{{ selectedMarker.title }}</h4>
          <div>Adresa: {{ selectedMarker.address_title }}</div>

          <div>
            <button
                @click.prevent="goToVenue(selectedMarker.id)"
                class="btn btn-sm btn-outline-primary ms-2">Editovat</button>

            <button
                @click.prevent="closeInfoBox"
                class="btn btn-sm btn-outline-danger"
            >
              Zavřít
            </button>
          </div>

          <!--
          <p>{{ selectedMarker }}</p>
          -->
        </div>
      </ol-overlay>

      <!--pickup-->
      <ol-vector-layer ref="vectorLayer">
        <ol-source-vector ref="vectorSource">
          <ol-feature
              ref="markerDraggable"
              :properties="{ draggable: true }"
          >
            <ol-geom-point
                :coordinates="fromLonLat(mapObj.center)"
            >
            </ol-geom-point>
            <ol-style>
              <ol-style-icon
                  :src="'/img/map/bug-red.svg'"
                  :scale="1.75"
                  :anchor="[0.5, 0.5]">
              </ol-style-icon>
            </ol-style>
            <ol-interaction-modify
                @modifyend="handleModifyEnd"
            ></ol-interaction-modify>
          </ol-feature>
        </ol-source-vector>
      </ol-vector-layer>

      <!-- drawing -->
      <ol-vector-layer
          v-if="1==0"
          ref="drawingLayer">
        <ol-source-vector ref="drawingSource">
          <ol-interaction-draw
              :active="true"
              type="Polygon"
              @drawend="onDrawEnd"
          />
        </ol-source-vector>
      </ol-vector-layer>
    </ol-map>
  </div>
  <!--
  <div
    class="multiselect-wrap"
  >
    <VueMultiselect
        v-model="mapSearch.selected"
        :options="options"
        track-by="id"
        :placeholder="'Vyhledat lokalitu'"
        @open="searchVenue"
        @search-change="searchVenue"
        class="-form-control"
    >

      <template v-slot:noOptions>
        <div class="multiselect--no-results">Vyhledejte jidlo pomocí názvu</div>
      </template>

      <template v-slot:noResult>
        <div class="multiselect--no-results">Žádné výsledky pro tento dotaz X.</div>
      </template>

      <template v-slot:option="{ option, search }">
        <div
            class="d-flex align-items-center"
        >

          <div class="d-inline-block align-self-center">
            <div class="xd-inline-block">
              {{option}}
            </div>
          </div>
        </div>
      </template>

      <template v-slot:singleLabel="{ option }">
        <div
            class="d-flex align-items-center"
        >
          <div class="align-self-center rounded">
            <span>
                   {{option}}
            </span>
          </div>
        </div>
      </template>

    </VueMultiselect>
  </div>

    <display-debug>
    <template #debugView>
      geoCodingResults: {{geoCodingResults}}
    </template>

  </display-debug>


  -->
  <div
    v-if="formObj.general.inputs.display_type_id.val == 2"
    class="mt-2"
  >
    <div class="mapa mada-draw">
      <ol-map
          ref="drawMapObj"
          :loadTilesWhileAnimating="true"
          :loadTilesWhileInteracting="true"
          :zoom="15"
          style="height: 100%;"
      >
        <!--  -->
        <ol-view
            ref="drawView"
            :center="fromLonLat(mapObj.center)"
            :zoom="12"
        />
        <!-- Základní mapová vrstva -->
        <ol-tile-layer>

          <ol-source-xyz
              v-if="mapObj.mapBoxUrl"
              :url="mapObj.mapBoxUrl"
          />
          <ol-source-osm v-else />
        </ol-tile-layer>

        <!-- control
        <ol-fullscreen-control />

        -->


        <ol-vector-layer>
          <ol-source-vector
              ref="drawingSource"
          >
            <!--
            <ol-feature
                ref="drawingSourceFeatures"
            >
              <ol-geom-polygon :coordinates="[devDraw.rawData]" />
              <ol-style>
                <ol-style-fill color="rgba(0, 0, 255, 0.3)" />
                <ol-style-stroke color="blue" :width="2" />
              </ol-style>
            </ol-feature>
            -->
          </ol-source-vector>

          <!-- Interakce pro kreslení -->
          <!--
          <ol-interaction-draw
              v-if="devDraw.isCreate"
              :source="$refs.drawingSource"
              type="Polygon"
              @drawend="onDrawEnd"
          ></ol-interaction-draw>
-->
          <!-- Interakce pro úpravu -->
          <!--
             <ol-interaction-modify
                 v-if="devDraw.isModify"
                 :source="$refs.drawingSource"
                 @modifyend="onModifyEnd"
             ></ol-interaction-modify>

             -->
        </ol-vector-layer>
        <!-- drawing -->

      </ol-map>
    </div>
    </div>




<!--
  <display-debug>
    <template #debugView>
      devDraw: {{devDraw}}
    </template>

  </display-debug>

  <display-debug>
    <template #debugView>
      formObj.general: {{formObj.general.inputs.display_type_id.val}}
    </template>

  </display-debug>
-->



  <div
    class="input-group mt-2"
  >
    <input
      v-model="mapSearch.query"
      type="text"
      placeholder="Vyhkedej na mape"
      class="form-control"
    >

    <button
        @click.prevent="onMapSearch()"
        class="btn btn-sm btn-outline-secondary"
    >
      <i class="bi bi-zoom-in"></i> {{$t('location.form.title.btn_search_on_map')}}
    </button>
  </div>

  <div
    v-if="mapSearch.isSearch"
  >
    <div @click.prevent="mapSearch.isSearch=false;">[zavrit]</div>
    <ul
      v-if="mapSearch.results.length > 0"
    >
      <li
          v-for="(location) in mapSearch.results"
          @click.prevent="onClickSearchResult(location)"
      >
        <span>{{location.title}}</span>
      </li>
    </ul>
    <div
        v-else
    >
      [nejsou vysledky]
    </div>

  </div>




</template>

<script>
import {fromLonLat, toLonLat} from "ol/proj";

let timer;
const timer_delay = 750;
const latLngDigit = 5
import axios from "axios";
import multiselect  from 'vue-multiselect'
import {Feature, OSMSource} from "ol";
import { Polygon } from 'ol/geom';
import Point from 'ol/geom/Point';
import { Style, Icon, Fill, Stroke } from 'ol/style';
import {Draw} from 'ol/interaction'
import { Collection } from 'ol/Collection';
import Modify from 'ol/interaction/Modify'
import DisplayDebug from "@/components/general/DisplayDebug.vue";
import VueMultiselect from "vue-multiselect";
//const GOOGLE_MAPS_API_KEY = 'AIzaSyCBIZYkBnui4cNdyw
//
// YaxSY-dpjWCk38ay4';


export default {
  name: "AddressInput",
  components: {
    VueMultiselect,
    DisplayDebug,
    axios,
    multiselect,
    Feature,
    OSMSource,
    Point,
    Style,
    Icon,
    Draw,
    Polygon,
    Collection,
    Modify,
    Fill,
    Stroke
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Object],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      address : {
        "lat": null,
        "lng": null,
        "city": null,
        "district": null,
        "country": null,
        "zip": null,
        "street": null,
        "house_number": null,
        "polygon": null,

      },

      cursor: null,
      //mapCenter: { lat: 50.07834352012642, lng: 14.442663210043822 },
      mapCenter: { lat: null, lng: null },
      mapObject: null,
      address_search_input: null,
      address_search_result: [],
      inputModel: null,

      mapObj: {
        center: [14.4454686, 50.0693217],
        cursor: [14.4454686, 50.0693217],
        zoom: 13,
        mapBoxUrl : this.getConfig('map.mapBoxStyleUrl'),
        markers: [],
      },
      selectedMarker: null,
      mapSearch: {
        query: null,
        isSearch: false,
        results: [],
        selected: null,
        timer: null,
      },
      geoCodingResults: [],
      options: [],
      drawing: {
        draw: null,
        modify: null,
        snap: null
      },
      drawObj: {
        drawInteraction: null,

      },
      devDraw: {
        "polygon": [
          [
            14.264464272752523,
            50.17189802092284
          ],
          [
            14.738481223592466,
            50.175429761957645
          ],
          [
            14.708166186038747,
            49.932901691632225
          ],
          [
            14.24517288521834,
            49.92757713921563
          ],
          [
            14.264464272752523,
            50.17189802092284
          ]
        ],
        rawData: [],
        isModify: false,
        isCreate: false,
      },


    }
  },
  setup() {

  },
  mounted() {

    const lastGPS = this.getGPS()
    //console.log('mounted lastGPS', lastGPS)
    if(lastGPS){
      this.mapObj.center= [lastGPS.lng, lastGPS.lat];
    }else{
      if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition((position) => {
              this.mapObj.center = [position.coords.longitude, position.coords.latitude];
            },
            (error) => {
              this.mapObj.center = [this.getConfig('map.defaultPosition.lng'), this.getConfig('map.defaultPosition.lat')];
            }
        );
      }
    }


    //console.log('mounted inputModel', this.inputModel)
    //console.log('mounted inputObj', this.inputObj.val)

    if(this.inputObj.val){
      this.address = this.inputObj.val;
      this.mapObj.center = [this.address.lng, this.address.lat];

    }else{
      this.address = {
        "lat": null,
        "lng": null,
        "street": null,
        "number": null,
        "city": null,
        "district": null,
        "country": null,
        "zip_code": null,
        "code": null,
      };
    }

    //map click
    const mapObj = this.$refs.mapObj
    if(mapObj) {
      mapObj.map.on('click', (event) => {
        const feature = mapObj.map.forEachFeatureAtPixel(event.pixel, (feature) => feature)
        if (feature) {
          const featureProperties = feature.getProperties()
          if(featureProperties.isClickable){
            this.selectedMarker = featureProperties.property;
            //console.log('dev marker click',this.selectedMarker);
          }

        }
      })
    }

/*
    mapObj.map.on('pointermove', (event) => {
        const pixel = mapObj.getEventPixel(event.originalEvent);
        const hit = mapObj.hasFeatureAtPixel(pixel);
        //this.map.getTargetElement().style.cursor = hit ? 'pointer' : '';
        if (hit) {
          const features = this.map.getFeaturesAtPixel(pixel);
          features.forEach((f) => {
            if (f.get('name')) {
              console.log(`Přejíždíte nad: ${f}`); //.get('name')
            }
          });
        }
    })
    */
    this.$nextTick(() => {
      //this.prepareDrawing()
    })

  },
  computed: {
    latLngStep() {
      return 1/Math.pow(10, this.inputObj.options.latLngDigits)
    }
  },
  methods: {
    fromLonLat,
    toLonLat,
    Feature,

    onMoveEnd(event) {
      if (event && event.target) {
        const map = event.target
        const view = map.getView()
        this.mapObj.zoom = Math.round(view.getZoom())
      }
    },

    handleModifyEnd(event) {
      const coordinates = event.features.getArray()[0].getGeometry().getCoordinates()
      this.mapObj.center = toLonLat(coordinates);
      this.setGPS(this.mapObj.center[1], this.mapObj.center[0])
      this.findLocaleByGPS(this.mapObj.center[1], this.mapObj.center[0])
      this.findAroundByGPS(this.mapObj.center[1], this.mapObj.center[0])
      //console.log("handleModifyEnd center", this.mapObj.center);
    },


    findLocaleByGPS(lat, lng) {
      const url = `https://nominatim.openstreetmap.org/reverse?format=json&addressdetails=1&lat=${lat}&lon=${lng}`
      axios({
        url: url,
        method: 'get',
      }).then((res) => {

        //console.log("handleModifyEnd findLocaleByGPS RES type", res.data.addresstype);
        this.fillAddress({
          ...res.data.address,
          lat: res.data.lat,
          lng: res.data.lon,
          code: res.data.place_id,
          addressType: res.data.addresstype,
        })

      }).catch((err) => {
          console.error("DEV findLocaleByGPS ERR", err);
      }).finally(() => {

      })
    },

    findAroundByGPS(lat, lng) {
      let formData = new FormData();
      formData.append('gps', JSON.stringify({
        lat: lat,
        lng: lng
      }));

      formData.append('radius', this.getConfig('map.venue.radius'));

      if(
          this.formObj.general.inputs.id
          && this.formObj.general.inputs.id.val
      ) {
        formData.append('id', this.formObj.general.inputs.id.val);
      }

      const vectorSource = this.$refs.vectorSourceMarker.source;
      vectorSource.clear();

      axios.defaults.baseURL = this.getBaseRoot();
      let apiPath = this.getApiConfig('venue.get_list_around_from_gps.path')
      axios({
        url: apiPath,
        data: formData,
        method: this.getApiConfig('venue.get_list_around_from_gps.method'),
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        console.log("handleModifyEnd findAroundByGPS RES", res.data.response.list);
        if(res.data.response.list.length > 0) {
          for(const i in res.data.response.list) {
            const feature = new Feature({
              geometry: new Point(fromLonLat([res.data.response.list[i].lng, res.data.response.list[i].lat])),
              isClickable: true,
              property: res.data.response.list[i],
            });

            // Přidání stylu pro marker (volitelné)
            feature.setStyle(
                new Style({
                  image: new Icon({
                    src: '/img/map/geo-marker-green.svg',
                    scale: 2,
                    anchor: [0.5, 1]
                  })
                })
            );

            // Přidání markeru do zdroje
            vectorSource.addFeature(feature);

          }
        }else{
          this.mapObj.markers = []
        }

      })
      .catch((err) => {
        this.mapObj.markers = []
        console.error("findAroundByGPS ERR", err);
      })
      .finally(() => {
        //this.$refs.mapObj.map.updateSize();
        //this.$refs.mapObj.map.render();
      })
    },

    createTitle(title) {
      if(
        typeof this.formObj.general.inputs.title.val == "undefined"
        || !this.formObj.general.inputs.title.val
      ){
        this.formObj.general.inputs.title.val = title
      }
    },


    createAddressTitle(address){

      const value = []

      let street = '';
      if(this.address.street){
        street += this.address.street
      }
      if(this.address.number){
        if(street != ''){
          street += ' ';
        }
        street += this.address.number
      }
      value.push(street);
      value.push(address.city);
      value.push(address.zip_code);
      //TODO stat

      this.formObj.general.inputs.address_title.val = value.join(', ')
    },

    goToVenue(id) {
      this.$router.push('/venue/edit/' + id);
    },

    closeInfoBox() {
      this.selectedMarker = null
    },

    onMapSearch() {
      //console.log('dev mapSearch', this.mapSearch.query);
      this.mapSearch.isSearch = true;

      const apiPath = 'https://nominatim.openstreetmap.org/search?q=' + this.mapSearch.query + '&format=json&addressdetails=1&osm_type=place'
      axios({
        url: apiPath,
        method: 'get',

      }).then((res) => {
        this.mapSearch.results = []
        if(res.data.length > 0){
          for(const i in res.data) {
            const item = {
              title: res.data[i].display_name,
              type: res.data[i].type,
              address: res.data[i].address,
              lat: res.data[i].lat,
              lng: res.data[i].lon,
              code: res.data[i].place_id,
            }
            this.mapSearch.results.push(item)
            console.log("onMapSearch RES", res.data[i]);
          }
        }
      })
      .catch((err) => {
        this.mapSearch.results = []
        console.error("onMapSearch ERR", err);
      })
      .finally(() => {
         //console.log('dev this.$refs.mapObj.map.render()');
      })

    },

    onClickSearchResult(detail) {
      //console.log('dev onClickSearchResult', detail);
      //console.log('dev onClickSearchResult', [detail.lng, detail.lat]);
      //console.log('dev onClickSearchResult', this.mapObj);
      this.mapObj.center = [detail.lng, detail.lat]

      const forAddress = {
        ...detail.address,
        lat: detail.lat,
        lng: detail.lng,
        code: detail.code,
      }

      this.fillAddress(forAddress)
      this.mapSearch.isSearch = false;
    },


    fillAddress(address) {
      //console.log('dev fillAddress', address);
      this.address.lat = parseFloat(address.lat).toFixed(6);
      this.address.lng = parseFloat(address.lng).toFixed(6);
      if(typeof address.lot != "undefined") {
        this.address.lng = parseFloat(address.lot).toFixed(6);
      }

      //mesto
      if(typeof address.city != "undefined") {
        this.address.city = address.city;
      }else if(typeof address.town != "undefined"){
        this.address.city = address.town;
      }else if(typeof address.village != "undefined"){
        this.address.city = address.village;
      }

      //ulice
      if(typeof address.road != "undefined"){
        this.address.street = address.road;

      }else if(typeof address.suburb != "undefined"){
        this.address.street = address.suburb;
      }else if(typeof address.village != "undefined"){
        this.address.street = address.village;
      }

      //kraj
      if(typeof address.county != "undefined"){
        this.address.district = address.county;
      }else if(typeof address.city != "undefined"){
        this.address.district = address.city;
      }

      this.address.zip_code = address.postcode;

      this.address.number = address.house_number;

      this.address.code = address.code;

      this.createAddressTitle(this.address);

      if(address.amenity != "undefined"){
        this.createTitle(address.amenity);
      }
    },


    //VUE SELECT
    async searchVenue (query) {
      let apiPath = this.getApiConfig('venue.get_options_list.path')
      if(query) {
        apiPath +="?" + this.getApiConfig('venue.get_options_list.input') + '=' + query;
      }

      if(timer) clearInterval(timer);
      timer = setTimeout(
          () => {
            axios.defaults.baseURL = this.getBaseRoot();
            axios({
              url: apiPath,
              method: 'get', //this.getApiConfig('venue.get_options_list.method')
              withCredentials: true,
              headers: this.getRequestHeader(),
            }).then((res) => {
              this.options = res.data.response.list;
            })
            .catch((err) => {
              this.options = []
            })
            .finally(() => {
              //console.log("DEV tags finally");
            })
          },
          500
      )
    },


    async searchLocationOpen(query) {
      console.log('dev searchLocationOpen #1', query);
      console.log('dev searchLocationOpen this.geoCodingResults', this.geoCodingResults);
    },

    async searchLocationChange(query) {
      this.geoCodingResults = []
      console.log('dev searchLocationChange #1', query);
      this.geoCodingResults.push({
        "title": "X " + Math.random().toString(36).substr(2, 10),
        "type": "administrative",
        "address": {
          "suburb": "Praha",
          "city_district": "obvod Praha 4",
          "city": "Hlavní město Praha",
          "ISO3166-2-lvl6": "CZ-10",
          "state": "Praha",
          "country": "Česko",
          "country_code": "cz"
        },
        "lat": "50.0596288",
        "lng": "14.446459273258009",
        "code": 121689254
      })



/*
      if(timer) clearInterval(timer);
      timer = setTimeout(
          () => {


            this.geoCodingResults.push({
              "title": "Hlavní město Praha, Praha, Česko",
              "type": "administrative",
              "address": {
                "city": "Hlavní město Praha",
                "ISO3166-2-lvl6": "CZ-10",
                "state": "Praha",
                "country": "Česko",
                "country_code": "cz"
              },
              "lat": "50.0874654",
              "lng": "14.4212535",
              "code": 122224714
            },)
            this.geoCodingResults.push({
              "title": "LAST Praha, okres Lučenec, Banskobystrický kraj, Střední Slovensko, Slovensko",
              "type": "administrative",
              "address": {
                "village": "Praha",
                "county": "okres Lučenec",
                "state": "Banskobystrický kraj",
                "ISO3166-2-lvl4": "SK-BC",
                "region": "Střední Slovensko",
                "country": "Slovensko",
                "country_code": "sk"
              },
              "lat": "48.3629587",
              "lng": "19.508195",
              "code": 174722062
            })

            console.log('dev searchLocationChange this.geoCodingResults', this.geoCodingResults);
          },
          1
      )
      */

/*
      if(
          query !== null
          && query !== ''
          && query.length > 3
      ) {
        console.log('SET RESULT', query);

      }
    */
    },


    prepareDrawing() {
      console.log('dev prepareDrawing', this.address.polygon)
      const mapObj =  this.$refs.drawMapObj;
      const viewRef =  this.$refs.drawView;
      if(this.address.polygon) {
        let coords = [];
        for(const lonLat of this.address.polygon){
          coords.push(fromLonLat(lonLat))
        }

        this.devDraw.rawData = coords;

        this.initialPolygon = new Polygon([coords]);




        // Vytvoříme feature s touto geometrií
        const polygonFeature = new Feature({
          geometry: this.initialPolygon
        });

        polygonFeature.setStyle(
            new Style({
               fill: new Fill({
                color: 'rgba(255, 0, 0, 0.15)'
              }),
              stroke: new Stroke({
                color: 'rgba(255, 0, 0, 1)',
                width: 1
              })
            })
        );



        this.$refs.drawingSource.source.addFeature(polygonFeature);
        polygonFeature.on('change', () => {
          //console.log('dev prepareDrawing change', polygonFeature.getGeometry().getCoordinates())
        });

        this.addModifyInteraction();


        //nastavim mapu
        const extent = this.initialPolygon.getExtent();
        viewRef.fit(extent, { padding: [50, 50, 50, 50] });


      }else{
        //todo kresleneni

        if(mapObj){
          if (this.drawObj.drawInteraction) {
            this.map.removeInteraction(this.drawObj.drawInteraction)
          }
          // Vytvoříme nový Draw interaction
          const drawInteraction = new Draw({
            source: this.$refs.drawingSource.source,
            type: 'Polygon'
          })

          // Přidáme event listener pro dokončení kresby
          drawInteraction.on('drawend', this.handleDrawEnd)

          // Přidáme Draw interaction do mapy
          this.drawObj.drawInteraction = drawInteraction
          mapObj.map.addInteraction(drawInteraction)


        }
      }
    },

    handleDrawEnd(event) {
      const feature = event.feature
      const geometry = feature.getGeometry()
      console.log('dev handleDrawEnd x', geometry.getCoordinates())
      this.address.polygon = this.convertToGps(geometry.getCoordinates()[0]) ;
    },

    addModifyInteraction() {
      const mapObj = this.$refs.drawMapObj

      // Vytvoříme nový Modify interaction
      const modifyInteraction = new Modify({
        source: this.$refs.drawingSource.source
      })

      modifyInteraction.on('modifyend', (event) => {
        const features = event.features
        features.forEach((feature) => {
          const geometry = feature.getGeometry()
          // Aktualizace souřadnic
          //console.log('dev prepareDrawing modifyend', geometry.getCoordinates()[0])
          this.address.polygon = this.convertToGps(geometry.getCoordinates()[0]) ;
        })
      })
      this.drawObj.drawInteraction = modifyInteraction
      mapObj.map.addInteraction(modifyInteraction)
    },

    convertToGps(input) {
      let output = [];
      if(input){
        for (const points of input){
          output.push(toLonLat(points))
        }
      }
      return output
    },


    onDrawEnd(event) {
      // Po dokončení kreslení aktualizujeme souřadnice
      const geometry = event.feature.getGeometry();
      console.log('dev onDrawEnd' , geometry.getCoordinates())
      //this.polygonCoordinates = [geometry.getCoordinates()[0]];
      //this.drawActive = false; // Deaktivujeme kreslení
    },


    searchLocation(query) {



      /*
      if(timer) clearInterval(timer);
      timer = setTimeout(
          () => {
            console.log('SET RESULT', query);

            //console.log('SET RESULT X', this.mapSearch.results);
          },
          50
      )
*/



      //this.mapSearch.results.push('testovaci hodnota')
      //this.mapSearch.results.push('b')
      //this.mapSearch.results.push('c')

      if(query) {
        this.mapSearch.results = []
        if(this.mapSearch.timer) clearInterval(this.mapSearch.timer);
        this.mapSearch.timer = setTimeout(
            () => {
              console.log('dev searchLocation', query);
              const apiPath = 'https://nominatim.openstreetmap.org/search?q=' + query + '&format=json&addressdetails=1&osm_type=place'
              axios({
                url: apiPath,
                method: 'get',
              }).then((res) => {

                if(res.data.length > 0){
                  for(const i in res.data) {
                    const item = {
                      title: res.data[i].display_name,
                      type: res.data[i].type,
                      address: res.data[i].address,
                      lat: res.data[i].lat,
                      lng: res.data[i].lon,
                      code: res.data[i].place_id,
                    }
                    //this.mapSearch.results.push(item)
                    //this.mapSearch.results.push(i)

                    console.log("onMapSearch RES", res.data[i]);
                  }
                }
              })
              .catch((err) => {
                this.mapSearch.results = []
                console.error("onMapSearch ERR", err);
              })
              .finally(() => {
                //console.log('dev this.$refs.mapObj.map.render()');
                this.mapSearch.results.push({
                  'title': 'konec',
                  'type': 'end',
                })
              })


            },
            50
        )
      }
    }
  },

  watch: {
    "formObj.general.inputs.display_type_id.val": {
      handler(newVal) {
        if(newVal == 2){
          setTimeout(
              () => {
                this.prepareDrawing()
              },
              100
          )

        }else{

        }
        console.log('watch formObj.general.inputs.display_type_id.val', newVal);
      },
      deep: true,
      immediate: true
    },


    address_search_input: {
      handler(newVal) {
        if(newVal && newVal.length > 0){
          if(timer) clearInterval(timer);
          timer = setTimeout(
              () => {
                 this.getGeocodingByAddress(newVal);
              },
              500
          )
        }else{
          this.address_search_result = [];
        }
        console.log('watch address_search_input', newVal)
      },
      //deep: true,
      //immediate: true
    },
/*
    inputObj: {
      handler() {
        //this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },
*/
    address: {
      handler(newVal) {
        this.$emit('update:modelValue', newVal )
      },
      deep: true,
      immediate: true
    },

  },
};
</script>

<style lang="scss" scoped>

.mapa {
  width: 100%;
  height: 400px;
  border: 1px dashed red;
}

.map-container {
  width: 100%;
  height: 600px;
}

.info-box {
  background: white;
  padding: .7rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 100px;
  max-width: 33vw;

  &[data-zoom][data-zoom="15"] {
    background-color: red;
  }
  &[data-zoom][data-zoom="10"] {
    background-color: navy;
  }

}
/*
.info-box button {
  margin-top: 10px;
  padding: 5px 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.info-box button:hover {
  background: #0056b3;
}
*/
</style>
